const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/setup-initial-password.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { toSafeRedirectPath } from '@/utils/safe-redirect';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/auth/setup-initial-password')({
  validateSearch: search => ({
    code: search.code as string,
    redirect: toSafeRedirectPath(search.redirect)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}